import { render, staticRenderFns } from "./LicenseFileList.vue?vue&type=template&id=1d841437&scoped=true&"
import script from "./LicenseFileList.vue?vue&type=script&lang=ts&"
export * from "./LicenseFileList.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseFileList.vue?vue&type=style&index=0&id=1d841437&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d841437",
  null
  
)

export default component.exports